module.exports = __webpack_public_path__ + "img/close.f7002f24.png";